@if (!isLoginMode()) {
<mat-toolbar color="primary" class="app-toolbar">
  @if (!isContextMode() && isMobile()) {
    <button mat-icon-button (click)="toggleMobileMenu()" [attr.aria-label]="'toolbar.menu' | t">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <div class="toolbar-brand">
    @if (shouldShowToolbarLogo()) {
      <img [src]="toolbarLogoUrl()" alt="" class="toolbar-logo" (error)="onToolbarLogoError()" />
    } @else {
      <div class="toolbar-logo-fallback">{{ toolbarLogoFallback() }}</div>
    }
    <span class="toolbar-title" [matTooltip]="toolbarFullTitle()" matTooltipPosition="below">{{ toolbarTitle() }}</span>
  </div>
  <span class="toolbar-spacer"></span>
  @if (rootSupportSessionType()) {
    <div class="root-support-session">
      <mat-icon>admin_panel_settings</mat-icon>
      <span>{{ rootSupportSessionLabel() }}</span>
      <button mat-button type="button" (click)="endRootSupportSession()">{{ 'toolbar.endRootSupportSession' | t }}</button>
    </div>
  }
  @if (!isMobile()) {
  <button mat-button class="language-link" [matMenuTriggerFor]="languageMenu" [attr.aria-label]="'toolbar.language' | t">
    <span class="language-link-code">{{ languageCode(currentLanguage()) }}</span>
    <mat-icon>expand_more</mat-icon>
  </button>
  }
  <mat-menu #languageMenu="matMenu" xPosition="before">
    @for (item of languageOptions; track item.code) {
      <button mat-menu-item (click)="switchLanguage(item.code)">
        <span class="menu-language-code">{{ languageCode(item.code) }}</span>
        <span>{{ item.label }}</span>
      </button>
    }
  </mat-menu>
  @if (showLogoutAction()) {
    @if (isMobile()) {
    <div class="toolbar-mobile-account" [matTooltip]="accountDisplayName()" matTooltipPosition="below">
      <mat-icon>account_circle</mat-icon>
      <span>{{ accountDisplayName() }}</span>
    </div>
    <button mat-icon-button class="toolbar-mobile-menu-button" [matMenuTriggerFor]="mobileToolbarMenu" [attr.aria-label]="'toolbar.menu' | t">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #mobileToolbarMenu="matMenu" xPosition="before">
      @if (isInstructorMode()) {
        <a mat-menu-item [routerLink]="['/instructor/help']"><mat-icon>help_outline</mat-icon><span>{{ 'help.title' | t }}</span></a>
      }
      <div class="mobile-menu-account" mat-menu-item disabled>
        <mat-icon>account_circle</mat-icon>
        <span>{{ accountDisplayName() }}</span>
      </div>
      @for (item of languageOptions; track item.code) {
        <button mat-menu-item (click)="switchLanguage(item.code)">
          <span class="menu-language-code">{{ languageCode(item.code) }}</span>
          <span>{{ item.label }}</span>
        </button>
      }
      <button mat-menu-item (click)="openChangePasswordDialog()">
        <mat-icon>lock_reset</mat-icon>
        <span>{{ 'account.changePassword.title' | t }}</span>
      </button>
      <button mat-menu-item (click)="logoutToContext()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'toolbar.logout' | t }}</span>
      </button>
    </mat-menu>
    } @else {
    <button mat-button class="account-link" [matMenuTriggerFor]="accountMenu" [attr.aria-label]="'toolbar.currentUser' | t">
      <mat-icon>expand_more</mat-icon>
      <mat-icon>account_circle</mat-icon>
      <span class="account-label">{{ accountDisplayName() }}</span>
    </button>
    <mat-menu #accountMenu="matMenu" xPosition="before">
      @if (isInstructorMode()) {
        <a mat-menu-item [routerLink]="['/instructor/help']"><mat-icon>help_outline</mat-icon><span>{{ 'help.title' | t }}</span></a>
      }
      <button mat-menu-item (click)="openChangePasswordDialog()">
        <mat-icon>lock_reset</mat-icon>
        <span>{{ 'account.changePassword.title' | t }}</span>
      </button>
    </mat-menu>
    <button mat-stroked-button class="toolbar-logout" (click)="logoutToContext()">
      <mat-icon>logout</mat-icon>
      {{ 'toolbar.logout' | t }}
    </button>
    }
  }
</mat-toolbar>
}

@if (!isContextMode()) {
  <mat-sidenav-container class="app-shell">
    <mat-sidenav
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="isMobile() ? mobileMenuOpen() : true"
      class="app-sidenav"
      (closedStart)="mobileMenuOpen.set(false)"
    >
      @if (isRootMode()) {
      <div class="nav-title">Admin</div>
      <mat-nav-list>
        @for (item of rootMenuItems; track item.path) {
          <a mat-list-item [routerLink]="[item.path]" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: item.path === '/admin' }" (click)="closeMobileMenu()">
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.labelKey | t }}</span>
          </a>
        }
      </mat-nav-list>
      } @else {
      <div class="nav-title">{{ 'nav.resources' | t }}</div>
      <mat-nav-list>
        @for (item of oskMenuItems(); track item.path) {
          <a
            mat-list-item
            [routerLink]="[item.path]"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: item.path === '/dashboard' }"
            (click)="closeMobileMenu()"
          >
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.labelKey | t }}</span>
          </a>
        }
        @if (canManageUsers()) {
        <a mat-list-item [routerLink]="['/admin/users']" routerLinkActive="active-link" (click)="closeMobileMenu()">
          <mat-icon matListItemIcon>manage_accounts</mat-icon>
          <span matListItemTitle>{{ 'nav.userManagement' | t }}</span>
        </a>
        }
      </mat-nav-list>
      }
    </mat-sidenav>

    <mat-sidenav-content>
      <main class="content-area">
        <router-outlet />
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <main class="content-area context-content" [class.login-content]="isLoginMode()" [class.instructor-mobile-content]="isInstructorMode()">
    <router-outlet />
  </main>
  @if (isInstructorMode()) {
    <nav class="app-instructor-bottom-nav" [attr.aria-label]="'instructor.mobileNav.label' | t">
      <a [routerLink]="['/instructor']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><mat-icon>dashboard</mat-icon><span>{{ 'instructor.overview.dashboard' | t }}</span></a>
      <button type="button" (click)="openCurrentInstructorCalendar()" [disabled]="!instructorCalendarEnabled()"><mat-icon>calendar_month</mat-icon><span>{{ 'calendar.title' | t }}</span></button>
      <a [routerLink]="['/instructor/lessons']" routerLinkActive="active"><mat-icon>schedule</mat-icon><span>{{ 'instructor.overview.dashboardLessons' | t }}</span></a>
      <a [routerLink]="['/instructor/students']" routerLinkActive="active"><mat-icon>groups</mat-icon><span>{{ 'instructor.overview.dashboardStudents' | t }}</span></a>
      <a [routerLink]="['/instructor/courses']" routerLinkActive="active"><mat-icon>school</mat-icon><span>{{ 'instructor.overview.dashboardCourses' | t }}</span></a>
      <a [routerLink]="['/instructor/resources']" routerLinkActive="active"><mat-icon>directions_car</mat-icon><span>{{ 'instructor.overview.dashboardResources' | t }}</span></a>
    </nav>
  }
}

@if (lessonsRetrying()) {
  <div class="retry-overlay" role="status" aria-live="polite">
    <div class="retry-panel">
      <mat-spinner diameter="44" />
      <div class="retry-text">
        <span>{{ 'common.loading' | t }}</span><span class="loading-dots" aria-hidden="true"></span>
      </div>
    </div>
  </div>
}
